import * as React from "react";
type Props = {
  className?: string,
};
function SvgSaveUpTo({ className }: Props) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-SaveUpTo"
      className={className}
    >
      <path
        d="M40.7131 16.4051C40.7131 16.3759 40.7129 16.3467 40.7126 16.3176M40.7126 16.3176C40.6428 9.71944 32.6753 6 22.8565 6C12.9945 6 5 9.75234 5 16.4051V20.3137C5 26.9665 12.9945 32.3597 22.8565 32.3597C32.7186 32.3597 40.7131 26.9665 40.7131 20.3137L40.7126 16.3176Z"
        stroke="#51312D"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M22.8565 26.502C32.7184 26.502 40.7131 21.9124 40.7131 16.251C40.7131 10.5895 32.7184 6 22.8565 6C12.9946 6 5 10.5895 5 16.251C5 21.9124 12.9946 26.502 22.8565 26.502Z"
        stroke="#51312D"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M7.04077 26.0454V29.954C7.04077 36.6068 15.0352 42 24.8973 42C34.7594 42 42.7538 36.6068 42.7538 29.954L42.7534 25.9579M42.7534 25.9579C42.7537 25.987 42.7538 26.0162 42.7538 26.0454M42.7534 25.9579C42.732 23.9363 41.9692 22.1849 40.6389 20.7279"
        stroke="#51312D"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M42.7538 25.8914C42.7538 31.5528 34.7592 36.1423 24.8973 36.1423C15.0354 36.1423 7.04077 31.5528 7.04077 25.8914"
        stroke="#51312D"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4843 18.887H18.0839C18.42 16.5882 20.5597 14.8156 23.1496 14.8156C25.7394 14.8156 27.879 16.5882 28.2153 18.887H32.8148C32.4617 14.2574 28.2695 10.6025 23.1496 10.6025C18.0296 10.6025 13.8374 14.2574 13.4843 18.887Z"
        fill="#51312D"
      />
    </svg>
  );
}
export default SvgSaveUpTo;
